import styled, { css } from 'styled-components'

import { color } from '../styles'
import { BORDER_RADIUS, SPACING, TRANSITION_TIME_MD_MS } from '../styles/mixins/constants'
import { text } from '../styles/mixins/text'
import { formatPlural } from '../util/string'

import { Icon } from './Icon/index'
import { Spacer } from './Spacer'

export const ContentContainerStyle = css`
    background-color: ${color.background.content};
    border: 1px solid ${color.border.primary};
    display: flex;
    flex: 0 0 auto;
    min-width: 0px;
    min-height: 0px;
    border-radius: ${BORDER_RADIUS};
    padding: ${SPACING[4]};
    ${(p: { hasDanger?: boolean }) =>
        p.hasDanger
            ? css`
                  background-color: ${color.status.dangerMuted};
              `
            : ''}
`

export const ContentContainer = styled.div<{
    children: JSX.Element | JSX.Element[] | string
    hasDanger?: boolean
}>`
    ${ContentContainerStyle}
`

export const CollapseContentContainer = (props: {
    isOpen: boolean
    title: string
    children: JSX.Element
    onToggle: (nextState: boolean) => void
}): JSX.Element => {
    const { isOpen, children, title, onToggle } = props
    return (
        <ContentContainer>
            <NoOverflowColumn>
                <ClickableRow onClick={() => onToggle(!isOpen)}>
                    <SectionTitle>{title}</SectionTitle>
                    <Spacer size="fill" />
                    <Icon iconKey={isOpen ? 'MinusSquare' : 'PlusSquare'} size={4} />
                </ClickableRow>
                <Content isOpen={Boolean(isOpen)}>{children}</Content>
            </NoOverflowColumn>
        </ContentContainer>
    )
}

export const ContentSectionTitle = styled.span`
    ${text('title', 'secondary', 'text', 'bold')}
`
const SectionTitle = styled(ContentSectionTitle)``

const NoOverflowColumn = styled.div`
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    max-height: 100%;
    min-height: 0;
    overflow: hidden;
`

const ClickableRow = styled.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    flex: 1 1 auto;
    min-height: 0;
    cursor: pointer;
`

const Content = styled.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    flex: 1 1 auto;
    align-items: flex-start;
    flex-wrap: wrap;
    max-height: 0;
    min-height: 0;
    opacity: 0;
    ${(p: { isOpen: boolean }) =>
        p.isOpen
            ? css`
                  max-height: 1000px;
                  opacity: 1;
              `
            : ''}
    transition: all ${TRANSITION_TIME_MD_MS}ms;
`

export const ErrorContainer = styled(ContentContainer).attrs({
    hasDanger: true,
})`
    flex-flow: column nowrap;
`

export const ErrorContent = (props: {
    data: string | string[] | null | undefined
}): JSX.Element | null => {
    const { data } = props
    const messages: string[] = []

    if (Array.isArray(data)) messages.push(...data)
    else if (data) messages.push(data)

    if (!messages.length) return null
    return (
        <ErrorContainer>
            <>
                {formatPlural({ value: 'Error', count: messages.length })}
                <ul>
                    {messages.map((message) => (
                        <li key={message}>{message}</li>
                    ))}
                </ul>
            </>
        </ErrorContainer>
    )
}
